define('module/lightbox',[
    'jquery',
    'underscore',
    'cnf',
    '_pubsub'
], function($, _, Cnf, Pubsub) {
    'use strict';

    /**
     * handle lightbox
     * 
     * @jira FDZ-491
     * @date 2021-07-08
     * @author sh@sopg.de
     */

    return function()
    {
        this.oPubsub = new Pubsub();

        this.cnf = {
            selector: {
                el: '.lightbox',
                loader: '.loader',
                holder: '.lightbox-holder',
                wrapper: '.wrapper',
                content: '.content',
                close: '.close'
            }
        };

        /**
         * main entry
         */
        this.init = function()
        {
            this.initElement();
            this.initEvent();
        }

        /**
         * init element
         */
        this.initElement = function()
        {
            this.$el = Cnf.$body.find(this.cnf.selector.el);
            this.$loader = this.$el.find(this.cnf.selector.loader);
            this.$holder = this.$el.find(this.cnf.selector.holder);
            this.$wrapper = this.$holder.find(this.cnf.selector.wrapper);
            this.$content = this.$el.find(this.cnf.selector.content);
            this.$close = this.$el.find(this.cnf.selector.close);
        }

        /**
         * init event
         */
        this.initEvent = function()
        {
            this.oPubsub.on(Pubsub.LIGHTBOX_SHOW, _.bind(this.show, this));
            this.oPubsub.on(Pubsub.LIGHTBOX_SET_CONTENT, _.bind(this.setContent, this));
            this.oPubsub.on(Pubsub.LIGHTBOX_UPDATE_CONTENT, _.bind(this.updateContent, this));

            this.$close.on('click', _.bind(this.hide, this));
            this.$holder.on('click', _.bind(this.checkClose, this));
        }

        /**
         * show lb
         * 
         * @param object ev
         */
        this.show = function(ev)
        {
            this.$el.attr('data-status', 'pending');

            var tl = new TimelineMax();
            tl.to(this.$el, .5, {
                autoAlpha: 1
            })
                .to(this.$loader, .5, {
                    autoAlpha: 1,
                    onComplete: _.bind(this.setContent, this, ev)
                });
        }


        /**
         * set content
         * 
         * @param object ev
         */
        this.setContent = function(ev)
        {
            if(typeof ev.html !== 'undefined') {
                this.$content.html(ev.html);

                //tmp workaround on throttled network
                _.delay(_.bind(this.setSize, this, ev), 100);
                _.delay(_.bind(this.setSize, this, ev), 500);
                _.delay(_.bind(this.setSize, this, ev), 2000);

                //trigger callback if given
                if(typeof ev.onReady === 'function') {
                    ev.onReady(this.$content);
                }

                if(typeof ev.colorscheme === 'string') {
                    this.$holder.attr('data-colorscheme', ev.colorscheme);
                }

                if(typeof ev.type === 'string') {
                    this.$holder.attr('data-type', ev.type);
                }

                if(ev.lazyload === true) {
                    $(window).trigger('dispatchLazyload', {el: this.$content[0]});
                }

                if(ev.tilewall === true) {
                    _.each(this.$content.find('.trigger-tilewall'), function(item)
                    {
                        this.oPubsub.trigger(Pubsub.TILEWALL_ADD_ITEM, $(item));
                    }, this)
                }

                if(ev.flickity === true) {
                    _.each(this.$content.find('.trigger-flickity'), function(item)
                    {
                        this.oPubsub.trigger(Pubsub.FLICKITY_ADD_ELEMENT, $(item));
                    }, this)
                }
                
                var tl = new TimelineMax();
                tl.to(this.$loader, .5, {
                    autoAlpha: 0,
                    onComplete: _.bind(function() {
                        this.$el.attr('data-status', 'active');
                    }, this)
                })
                    .to(this.$holder, .5, {
                        autoAlpha: 1,
                        onComplete: _.bind(function()
                        {
                            //trigger callback if given
                            if(typeof ev.onShow === 'function') {
                                ev.onShow(this.$content);
                            }
                        }, this)
                    })
            }
        }

        /**
         * update content
         * 
         * @param {object} ev 
         */
        this.updateContent = function(ev)
        {
            this.$el.attr('data-status', 'pending');

            var tl = new TimelineMax();
            tl.to(this.$holder, .5, {
                autoAlpha: 0
            })
                .to(this.$loader, .5, {
                    autoAlpha: 1,
                    onComplete: _.bind(this.setContent, this, ev)
                })
        }

        /**
         * hide lb
         */
        this.hide = function()
        {
            TweenMax.to(this.$el, .5, {
                autoAlpha: 0,
                onComplete: _.bind(function() {
                    //reset
                    TweenMax.set(this.$loader, {autoAlpha: 0});
                    TweenMax.set(this.$holder, {autoAlpha: 0});
                    this.$holder
                        .attr('data-type', '')
                        .attr('data-size', '')
                        .attr('data-colorscheme', '');
                    this.$content.html('');
                    this.$wrapper.attr('style', '');
                }, this)
            });
        }

        /**
         * set wrapper size
         * 
         * @jira FDZ-841
         * @updated 2025-05-30
         * @author sh@moinbits.de
         * 
         * @param [object] ev
         */
        this.setSize = function(ev)
        {
            this.$wrapper.attr('style', '');
            this.$holder.attr('data-size', '');

            var height = (this.$wrapper.height() + 200)
            if(height > window.innerHeight) {

                //on modalbox i.e. content-elements
                if(typeof ev.size === 'string') {
                    this.$holder.attr('data-size', ev.size);

                //defaults to ugc
                } else {
                    this.$wrapper.css('max-width', ((window.innerHeight - 100) * (this.$wrapper.width() / height)));
                }
            }
        }

        /**
         * callback on click to check propriate close element
         * 
         * @param {object} ev 
         */
        this.checkClose = function(ev)
        {
            if(ev.target.dataset.onclick === 'close') {
                this.hide();
            }
        }

        this.init();
    }
});
